import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../utils/api';
import { useTranslation } from 'react-i18next';

const BeritaDetailPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [berita, setBerita] = useState(null);
  const [loading, setLoading] = useState(true);

  // Get backend URL from api settings
  const backendUrl = api.defaults.baseURL.replace('/api', '');

  useEffect(() => {
    const load = async () => {
      try { const res = await api.get(`/berita/${id}`); setBerita(res.data.data); } catch (e) { console.error(e); } finally { setLoading(false); }
    };
    load();
  }, [id]);

  if (loading) return <div className="loading-spinner" style={{ minHeight: '100vh', paddingTop: 200 }}><div className="spinner" /></div>;
  if (!berita) return <div className="empty-state" style={{ paddingTop: 200 }}><h3>Berita tidak ditemukan</h3></div>;

  return (
    <div style={{ paddingTop: 100, minHeight: '100vh' }}>
      <div className="container" style={{ maxWidth: 800 }}>
        <Link to="/berita" style={{ color: 'var(--primary-500)', fontSize: '0.9rem' }}>← Kembali ke Berita</Link>
        <div style={{ marginTop: '1.5rem' }}>
          <span className="badge badge-info" style={{ marginBottom: '0.75rem' }}>{berita.kategori}</span>
          <h1 style={{ fontSize: 'clamp(1.5rem, 3vw, 2.2rem)', marginBottom: '0.75rem' }}>{berita.judul}</h1>
          <div style={{ display: 'flex', gap: '1rem', fontSize: '0.85rem', color: 'var(--gray-400)', marginBottom: '2rem' }}>
            <span>{new Date(berita.createdAt).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
            <span>👁 {berita.viewCount} kali dibaca</span>
          </div>
          <div style={{ background: 'var(--gray-100)', borderRadius: 16, minHeight: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '2rem', overflow: 'hidden' }}>
            {berita.gambar ? (
              <img 
                src={`${backendUrl}/uploads/${berita.gambar}`} 
                alt={berita.judul} 
                style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `<span style="color:rgba(0,0,0,0.1); font-size: 3rem; font-weight: 800">NGADHU</span>`;
                }}
              />
            ) : (
              <span style={{ color: 'var(--primary-300)', fontSize: '3rem', fontFamily: 'var(--font-display)', fontWeight: 800, opacity: 0.2 }}>NGADHU</span>
            )}
          </div>
          <div style={{ fontSize: '1.05rem', lineHeight: 1.8, color: 'var(--gray-700)' }}>
            <p style={{ fontWeight: 600, fontSize: '1.1rem', marginBottom: '1rem' }}>{berita.ringkasan}</p>
            <p>{berita.konten}</p>
          </div>
          {berita.tags?.length > 0 && (
            <div style={{ marginTop: '2rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              {berita.tags.map(t => <span key={t} className="badge badge-info">{t}</span>)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BeritaDetailPage;
